import { Injectable } from '@angular/core';
import { ElementRoute, ApiService, ElementsService } from 'dbweb-core';
export interface Controller {
	Name: string;
	Bill: boolean;
}
export interface IFetchElementInitDataResult {
	Controllers: Controller[];
	Categories: string[];
	CategoriesEN: string[];
	Roles: string[];
	CanSelectRoles: string[];
}
export interface MainColumn {
	Name: string;
	Type: string;
	PrimaryKey: boolean;
	MaxLength: number;
	Null: boolean;
}
@Injectable()
export class ElementBackFace {
	element: ElementRoute;
	constructor(private api: ApiService, private eles: ElementsService) {}
	private get<T>(method: string, param?: any) {
		return this.api.get<T>(this.element.apiURL(), method, this.eles.getURLSign(this.element.apiURL()), param);
	}
	private post<T>(method: string, param?: any) {
		return this.api.post<T>(this.element.apiURL(), method, this.eles.getURLSign(this.element.apiURL()), param);
	}
	fetchElementInitData(name: string) {
		return this.get<IFetchElementInitDataResult>('fetch-element-init-data', name);
	}
	fetchElementNames() {
		return this.get<string[]>('fetch-element-names');
	}
	fetchBillMainColumns(cname: string) {
		return this.get<MainColumn[]>('fetch-bill-main-columns', cname);
	}
	fetchTables(db: string) {
		return this.get<string[]>('fetch-tables', db);
	}
	fetchDB() {
		return this.get<string[]>('fetch-db');
	}
	checkSQL(param: { DB: string; Table: string; ManualPage: boolean; SQL: string }) {
		return this.post<{ Error: string; Columns: { Name: string; Type: string }[] }>('check-sql', param);
	}
	fetchTableColumns(table: string) {
		return this.get<string[]>('fetch-table-columns', table);
	}
}
